(ns common.schema.entities.lp-portal.lp-news-category
  (:require
   [common.schema.schema-utils :as su]))

(def schema
  (concat (su/text-simple-field :lp-news-category/display-name
                                "Display name"
                                {:not-clearable?   true
                                 :mandatory-config :mandatory/always
                                 :system-required? true
                                 :system-semantics
                                 su/user-provided-system-required-field-semantics
                                 :authorization    su/access-zadmin-lpg})
          (su/text-simple-field :lp-news-category/source-name "Source name" {:authorization su/access-zadmin-lpg})
          (su/text-simple-field :lp-news-category/source-id "Source id" {:authorization su/access-zadmin-lpg})
          (su/keyword-field :lp-news-category/source "Scraping source" nil {:authorization su/access-zadmin-lpg})))
